export class FileHandler {
    public static readJsonContents (file: string | Blob | File, success: (data: any) => void, error: () => void) {
        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const content = e.target?.result;
                try {
                    const json = JSON.parse(content as string);
                    return success(json);
                } catch (e) {
                    return error();
                }
            };

            reader.readAsText(file as Blob);
        }
    }
}